import {createNamespacedHelpers} from 'vuex'

const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('message')
import Module from './index.js'


export default {
    computed: {
        ...mapState(Object.keys(Module.state)),
        ...mapGetters(Object.keys(Module.getters))
    },
    methods: {
        ...mapMutations(Object.keys(Module.mutations)),
        ...mapActions(Object.keys(Module.actions)),
    },
}



// WEBPACK FOOTER //
// ./src/match/store/message/messageStoreMixin.js